import { EventType } from '@graphql/generated-base';

/**
 * Returns `true` for event types whose schedule data lives in the legacy
 * Firebase/wedding backend rather than the Postgres-backed pro pipeline.
 *
 * Used to branch schedule queries, mutations, and cache strategies.
 */
export const usesFirebaseScheduleBackend = (eventType: EventType | null | undefined): boolean => eventType === EventType.wedding || eventType === EventType.babyRegistry;
